
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import arrowLeftIcon from '../../../assets/icons/arrow_left_icon.svg'
import menuDataJson from '../../../assets/jsons/FrontMenuData.json'
const MenuItem = ({ menuData, index, openMenuIndex, setOpenMenuIndex }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const rute = location.pathname.split("/")[1];
    const routejson = menuData.url.split("/")[1];
    const mostrarSubMenu = openMenuIndex === index;
    const [heightMenu, setHeightMenu] = useState(null);

    const showSubMenu = () => {
        if (menuData.subMenu.length === 0) {
            navigate(menuData.url);
        } else {
            setOpenMenuIndex(mostrarSubMenu ? null : index);
        }
    };

    const handleSubMenuClick = (url) => {
        navigate(url);
        setOpenMenuIndex(null);
    };

    useEffect(() => {
        const menu = document.getElementById("MenuItem");
        const submenu = document.getElementById("subMenu");
        if(mostrarSubMenu)
        {
            const height = menu.offsetHeight;
            submenu.style.top=`${height}px`
        }
      
    }, [mostrarSubMenu])

    
    return (
        <div className={`MenuItem ${rute === routejson ? "seleccionado" : ""}`} id="MenuItem" onClick={showSubMenu}>
            <div className="title">{menuData.title}</div>
            <div className="iconContainer">
                {
                    menuData.subMenu.length !== 0 ?
                        <>
                            <img src={arrowLeftIcon}></img>
                        </> : ""
                }
            </div>
            {mostrarSubMenu && (
                <div className="subMenu" id={mostrarSubMenu ? "subMenu" : ""}>

                    {menuData.subMenu?.map((subMenuData, key) => {


                        return (
                            <>
                                <div
                                    className="titleSubMenu"
                                    key={subMenuData.title}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleSubMenuClick(subMenuData.url);
                                    }}
                                >
                                    {subMenuData.title}
                                </div>
                            </>
                        )
                    }
                    )}
                </div>
            )}
        </div>
    );
};

export default MenuItem;